import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

interface ScopePayload {
  name: string;
  description?: string;
  permissions: string[];
  is_active?: boolean;
}

class Scope {
  static ENDPOINT = 'api/v2/scopes';

  static async getScope(scopeId: string): Promise<APIResponseType> {
    if (!scopeId) throw new Error("Scope ID is required to fetch details");
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}/${scopeId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getAllScopes(): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addScope(payload: ScopePayload): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteScope(scopeId: string): Promise<APIResponseType> {
    if (!scopeId) throw new Error("Scope ID is required for deletion");
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${scopeId}`);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editScope(scopeId: string, payload: Partial<ScopePayload>): Promise<APIResponseType> {
    if (!scopeId) throw new Error("Scope ID is required for editing");
    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${scopeId}`, payload);
      await apiService.invalidateCacheByPrefix(this.ENDPOINT, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Scope; 